//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const SequentialInvokeBulkExecution: FeatureFlag = {"Id":"SequentialInvokeBulkExecution","Label":"(KILL)[10.24]SequentialInvokeBulkExecution","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Execute DynamicForms bulk invokes sequentially against the same form instance instead of queuing the old per-invoke tasks.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
